module.exports = __webpack_public_path__ + "img/example-1.05b4cc84.png";